import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";

const VENUE_PASSWORD = "venue2024";

export default function TapScreen({ onJoin, onNotif }) {
  const { user } = useAuth();
  const [showModeSelect, setShowModeSelect] = useState(false);
  const [showVenueLogin, setShowVenueLogin] = useState(false);
  const [venueInput, setVenueInput] = useState("");
  const [venueError, setVenueError] = useState("");
  const [tapAnimating, setTapAnimating] = useState(false);
  const [venueIdInput, setVenueIdInput] = useState("");
  const [showVenueInput, setShowVenueInput] = useState(false);

  const handleTap = () => {
    setTapAnimating(true);
    setTimeout(() => { setTapAnimating(false); setShowModeSelect(true); }, 700);
  };

  const handleVenueLogin = () => {
    if (venueInput === VENUE_PASSWORD) {
      setShowVenueLogin(false);
      setVenueInput("");
      setVenueError("");
      const venueId = venueIdInput || "demo-venue";
      onJoin(venueId, true);
    } else {
      setVenueError("Incorrect venue password");
    }
  };

  const handleGuestJoin = () => {
    const venueId = venueIdInput || "demo-venue";
    onJoin(venueId, false);
  };

  return (
    <div style={{
      minHeight: "100vh", background: "#0A0A0A", display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center", padding: "80px 40px",
      textAlign: "center", position: "relative", overflow: "hidden",
      fontFamily: "'DM Sans', system-ui, sans-serif",
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Serif+Display:ital@0;1&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { width: 0; }
        .tap-bg-circle { position: absolute; border-radius: 50%; background: rgba(29,185,84,0.15); animation: pulse-bg 3s ease-in-out infinite; }
        @keyframes pulse-bg { 0%, 100% { transform: scale(1); opacity: 0.05; } 50% { transform: scale(1.1); opacity: 0.08; } }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
        @keyframes ripple { 0% { box-shadow: 0 0 0 0 rgba(29,185,84,0.4); } 70% { box-shadow: 0 0 0 24px rgba(29,185,84,0); } 100% { box-shadow: 0 0 0 0 rgba(29,185,84,0); } }
        .tap-nfc-btn { width: 140px; height: 140px; border-radius: 50%; background: #1DB954; border: none; cursor: pointer; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px; position: relative; z-index: 1; transition: transform 0.15s ease; animation: ripple 2.5s ease-in-out infinite; font-family: 'DM Sans', sans-serif; color: #ffffff; }
        .tap-nfc-btn:active, .tap-nfc-btn.animating { transform: scale(0.88); }
        .mode-select { width: 100%; max-width: 480px; position: relative; z-index: 1; animation: slideUp 0.3s cubic-bezier(0.32, 0.72, 0, 1); background: rgba(29,185,84,0.08); border: 1px solid rgba(29,185,84,0.2); border-radius: 24px; padding: 24px; text-align: center; }
        .mode-btn { width: 100%; padding: 16px 20px; border-radius: 100px; border: none; cursor: pointer; font-family: 'DM Sans', sans-serif; font-size: 15px; font-weight: 600; transition: all 0.2s; display: flex; align-items: center; gap: 14px; margin-bottom: 10px; text-align: left; }
        .mode-btn:active { transform: scale(0.98); }
        .mode-btn-venue { background: #1DB954; color: #ffffff; font-weight: 700; }
        .mode-btn-venue:hover { background: #1aa34a; }
        .mode-btn-guest { background: rgba(255,255,255,0.06); color: #ffffff; border: 1.5px solid rgba(255,255,255,0.15); }
        .mode-btn-guest:hover { background: rgba(255,255,255,0.1); border-color: rgba(255,255,255,0.25); }
        .venue-input { width: 100%; padding: 14px 16px; border-radius: 12px; background: rgba(255,255,255,0.06); border: 1.5px solid transparent; font-family: 'DM Sans', sans-serif; font-size: 15px; color: #fff; outline: none; margin-bottom: 10px; transition: all 0.15s; }
        .venue-input:focus { border-color: rgba(255,255,255,0.3); background: rgba(255,255,255,0.08); }
        .venue-input::placeholder { color: rgba(255,255,255,0.3); }
        .modal-overlay { position: absolute; inset: 0; background: rgba(0,0,0,0.5); display: flex; align-items: flex-end; z-index: 100; backdrop-filter: blur(4px); animation: fadeIn 0.2s ease; }
        .modal-sheet { background: #1a1a1a; width: 100%; border-radius: 24px 24px 0 0; padding: 24px 24px 40px; animation: slideUp 0.3s cubic-bezier(0.32, 0.72, 0, 1); border-top: 1px solid rgba(255,255,255,0.08); }
        .modal-handle { width: 36px; height: 4px; background: rgba(255,255,255,0.2); border-radius: 2px; margin: 0 auto 20px; }
        .modal-title { font-size: 18px; font-weight: 700; color: #fff; margin-bottom: 4px; letter-spacing: -0.5px; }
        .modal-sub { font-size: 13px; color: rgba(255,255,255,0.5); margin-bottom: 20px; line-height: 1.5; }
        .modal-btn { width: 100%; padding: 14px; border-radius: 14px; border: none; font-family: 'DM Sans', sans-serif; font-size: 14px; font-weight: 600; cursor: pointer; margin-bottom: 8px; transition: all 0.15s; }
        .modal-btn:active { transform: scale(0.98); }
        .modal-btn-primary { background: #1DB954; color: #ffffff; border-radius: 100px; font-weight: 700; }
        .modal-btn-primary:hover { background: #1aa34a; }
        .modal-btn-cancel { background: rgba(255,255,255,0.06); color: rgba(255,255,255,0.5); }
        .modal-btn-cancel:hover { background: rgba(255,255,255,0.1); }
        .modal-error { font-size: 12px; color: #fca5a5; margin-bottom: 10px; background: rgba(220,38,38,0.1); border: 1px solid rgba(220,38,38,0.3); border-radius: 10px; padding: 8px 12px; }
        .tap-back { width: 100%; background: none; border: none; color: rgba(255,255,255,0.3); font-size: 13px; cursor: pointer; font-family: 'DM Sans', sans-serif; padding: 8px 0; margin-top: 4px; transition: color 0.15s; }
        .tap-back:hover { color: rgba(255,255,255,0.5); }
        .tap-manual { margin-top: 24px; background: none; border: none; color: rgba(255,255,255,0.3); font-size: 12px; cursor: pointer; position: relative; z-index: 1; font-family: 'DM Sans', sans-serif; transition: color 0.15s; }
        .tap-manual:hover { color: rgba(255,255,255,0.5); }
      `}</style>

      <div className="tap-bg-circle" style={{ width: 500, height: 500, top: -100, left: -50 }} />
      <div className="tap-bg-circle" style={{ width: 350, height: 350, top: 80, left: 80, animationDelay: "1s" }} />
      <div className="tap-bg-circle" style={{ width: 200, height: 200, bottom: 60, right: -40, animationDelay: "1.5s" }} />

      <div style={{ position: "relative", zIndex: 1, marginBottom: 48 }}>
        <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 48, color: "#fff", letterSpacing: -2, lineHeight: 1, marginBottom: 8 }}>tapped</div>
        <div style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", letterSpacing: 0.5 }}>your crowd, your sound</div>
      </div>

      {!showModeSelect ? (
        <>
          <button className={`tap-nfc-btn ${tapAnimating ? "animating" : ""}`} onClick={handleTap}>
            <span style={{ fontSize: 36 }}>📲</span>
            <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: 1, color: "#ffffff", textTransform: "uppercase" }}>Tap</span>
          </button>
          <div style={{ color: "rgba(255,255,255,0.3)", fontSize: 12, marginTop: 28, position: "relative", zIndex: 1, lineHeight: 1.5 }}>
            Hold near NFC sticker to connect
          </div>
          <button
            className="tap-manual"
            onClick={() => { setShowModeSelect(true); setShowVenueInput(true); }}
          >
            Or enter a venue ID manually
          </button>
        </>
      ) : (
        <div className="mode-select">
          {showVenueInput && (
            <div style={{ marginBottom: 16 }}>
              <input
                className="venue-input"
                placeholder="Venue ID (e.g. the-archer-bar)"
                value={venueIdInput}
                onChange={e => setVenueIdInput(e.target.value)}
              />
            </div>
          )}
          <button className="mode-btn mode-btn-venue" onClick={() => setShowVenueLogin(true)}>
            <span style={{ fontSize: 22 }}>🎵</span>
            <div style={{ textAlign: "left" }}>
              <div>Venue Mode</div>
              <div style={{ fontSize: 11, opacity: 0.7, fontWeight: 400, marginTop: 2 }}>Control playback · Manage queue</div>
            </div>
          </button>
          <button className="mode-btn mode-btn-guest" onClick={handleGuestJoin}>
            <span style={{ fontSize: 22 }}>🎧</span>
            <div style={{ textAlign: "left" }}>
              <div>Join as {user?.displayName || "Guest"}</div>
              <div style={{ fontSize: 11, opacity: 0.7, fontWeight: 400, marginTop: 2 }}>Request songs · Vote · Connect</div>
            </div>
          </button>
          <button
            className="tap-back"
            onClick={() => { setShowModeSelect(false); setShowVenueInput(false); }}
          >
            ← Back
          </button>
        </div>
      )}

      {showVenueLogin && (
        <div className="modal-overlay" onClick={() => setShowVenueLogin(false)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div className="modal-handle" />
            <div className="modal-title">Venue Login</div>
            <div className="modal-sub">Enter your venue password to enable playback control</div>
            <input
              className="venue-input"
              type="password"
              placeholder="Venue password"
              value={venueInput}
              onChange={e => setVenueInput(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleVenueLogin()}
              autoFocus
            />
            {venueError && <div className="modal-error">{venueError}</div>}
            <button className="modal-btn modal-btn-primary" onClick={handleVenueLogin}>Connect Spotify →</button>
            <button className="modal-btn modal-btn-cancel" onClick={() => { setShowVenueLogin(false); setVenueInput(""); setVenueError(""); }}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
}
